import React from 'react';
import { Container } from 'react-bootstrap';
import Button from '../../../components/Button';
import HealthFsaModal from './HealthFsaModal';

const HealthFSAModalDemo = () => {
  const [showHealthFSAModal, setShowHealthFSAModal] =
    React.useState<boolean>(false);

  const handleShowHealthFSAModal = () => setShowHealthFSAModal(true);
  const handleCloseHealthFSAModal = () => setShowHealthFSAModal(false);

  return (
    <Container>
      <Container className="mt-10">
        <h4>Health care FSA Modal</h4>
        <Button onMouseDown={handleShowHealthFSAModal}>Open Modal</Button>
        <HealthFsaModal
          showHealthFSAModal={showHealthFSAModal}
          handleCloseHealthFSAModal={handleCloseHealthFSAModal}
        />
      </Container>
    </Container>
  );
};

export default HealthFSAModalDemo;
